import { selectProduct } from 'Favourites/store/reducers/data/products';

import {
    selectExcludeVAT,
} from 'store/reducers/data/user';

export default class Price {
    state = null;
    productId = null;
    adapter = null;
    priceType = null;
    excludeVAT = false;

    setAdapter(Adapter) {
        this.adapter = new Adapter();
        return this;
    }

    setState(state) {
        this.state = state;
        this.excludeVAT = selectExcludeVAT(state);
        return this;
    }

    setProductId(id) {
        this.productId = id;
        return this;
    }

    setPriceType(type) {
        this.priceType = type;
        return this;
    }

    setExcludeVAT(value) {
        this.excludeVAT = value;
        return this;
    }

    getAdapter() {
        return this.adapter;
    }

    getUnitPrice() {
        return this.adapter.getUnitPrice(this._getProductState(), this.priceType, this.excludeVAT);
    }

    getTotalProductPrice() {
        return this.adapter.getTotalProductPrice(this._getProductState(), this.priceType, this.excludeVAT);
    }

    getPriceExpirationDate() {
        return this.adapter.getPriceExpirationDate(this._getProductState(), this.priceType, this.excludeVAT);
    }

    getOldPrice() {
        return this.adapter.getOldPrice(this._getProductState(), this.priceType, this.excludeVAT);
    }

    getOrderTotal() {
        return this.adapter.getOrderTotal(this.state, this.priceType, this.excludeVAT);
    }

    getOrderTotalExclVAT() {
        return this.adapter.getOrderTotal(this.state, this.priceType, true);
    }

    getOrderTotalVAT() {
        return this.adapter.getOrderTotalVAT(this.state, this.priceType);
    }

    getSpecialTaxes() {
        return this.adapter.getSpecialTaxes(this.state);
    }

    /**
     * Gets the order total plus delivery
     */
    getOrderGrandTotal() {
        return this.adapter.getOrderGrandTotal(this.state, this.priceType, this.excludeVAT);
    }

    getOrderGrandTotalVAT() {
        return this.adapter.getOrderGrandTotalVAT(this.state, this.priceType);
    }

    getOrderGrandTotalExclVAT() {
        return this.adapter.getOrderGrandTotal(this.state, this.priceType, true);
    }

    getGiftcardsTotal() {
        return this.adapter.getGiftcardsTotal(this.state);
    }

    getRefundcardsTotal() {
        return this.adapter.getRefundcardsTotal(this.state);
    }

    getLeftToPay() {
        return this.adapter.getLeftToPay(this.state);
    }

    isDiscounted() {
        return this.adapter.isDiscounted(this._getProductState());
    }

    isTRO() {
        return this.adapter.isTRO(this._getProductState(), this.priceType, this.excludeVAT);
    }

    isNLP() {
        return this.adapter.isNLP(this._getProductState(), this.priceType, this.excludeVAT);
    }

    _getProductState() {
        return selectProduct(this.state, this.productId);
    }
}
